<script setup>
import SandboxWeb from '@/components/sandbox/sandbox.vue'
import SandboxMobile from '@/components/sandbox/sandbox-mobile.vue'
const IS_Mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|HarmonyOS|OpenHarmony/i.test(navigator.userAgent);
const IS_H5 = IS_Mobile || window.innerWidth <= 768;
</script>
<template>
  <!-- /* 判读是从哪个入口进入 */ -->
  <SandboxMobile v-if="IS_H5" />
  <SandboxWeb v-else />
</template>
<style lang="scss" scoped></style>
